import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import { sanitizeHTML } from '../../utilities';
import MessageList from '../MessageList';
import OverlapMenuInnerWrapper from '../OverlapMenuInnerWrapper';
import Scrollbar from '../Scrollbar';

const HeaderMenuContent = () => {
  const { ui } = useStores();
  const {
    header: { background: headerBackground, color: headerColor },
    window: {
      colors: { main: mainColor }
    },
    headerMenu: { maxCountMainLayerItems, items, size, mobileView, colors },
    scrollBar
  } = useConfig();
  const { t } = useTranslation();
  const scrollbarRef = React.useRef(null);
  const containerRef = React.useRef(null);

  const maxMainLayerItems = maxCountMainLayerItems;
  const mainLayerItems =
    items.length > maxMainLayerItems ? items.slice(0, maxMainLayerItems) : items;
  const itemColors = {
    mainColor: colors.itemText,
    mainBackground: colors.itemBackground,
    hoverColor: colors.itemTextHover || headerColor,
    hoverBackground: colors.itemBackgroundHover || headerBackground
  };

  // eslint-disable-next-line consistent-return
  const handleClickMenuItem = menuItem => {
    document.getElementById('headerMenu').style.display = 'none';
    const parent = document.getElementById('messages-content');
    const childs = parent.childNodes;
    childs.forEach(child => {
      child.innerHTML = '';
    });
    if (menuItem.categoryId) {
      return ui.setCategory(menuItem.categoryId, menuItem.label);
    }
  };

  return (
    <Root ref={containerRef}>
      {ui.category.id ? (
        <MessageList />
      ) : (
        <>
          <StyledScrollbar
            renderView={({ style, ...props }) => {
              return (
                <ScrollbarView
                  {...props}
                  style={{
                    ...style,
                    overflowX: 'hidden',
                    bottom: '8px',
                    top: 0
                  }}
                />
              );
            }}
            autoHide
            ref={scrollbarRef}
            {...scrollBar}
          >
            <Wrapper
              contentPadding={ui.isMobile ? mobileView.contentPadding : size.contentPadding}
              mainColor={mainColor}
            >
              <WelcomeMessage
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(t('headerMenu.title'))
                }}
              />
              <Menu>
                <OverlapMenuInnerWrapper
                  data={mainLayerItems}
                  cardWidth={ui.isMobile ? mobileView.mainLayer.width : size.mainLayer.width}
                  cardHeight={ui.isMobile ? mobileView.mainLayer.height : size.mainLayer.height}
                  cardSidePadding={ui.isMobile ? mobileView.itemSidePadding : size.itemSidePadding}
                  cardImageSize={size.itemImage}
                  colors={itemColors}
                  onItemClick={handleClickMenuItem}
                  cardBoxShadow={colors.itemBoxShadow}
                />
              </Menu>
            </Wrapper>
          </StyledScrollbar>
        </>
      )}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  flex: 1 0 auto;
  display: flex;
  height: 100%;
  padding: 10px;
  font: inherit;
  line-height: normal;
`;

const StyledScrollbar = styled(Scrollbar)`
  height: 100%;
`;

const ScrollbarView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 0;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: ${props => props.contentPadding};
  color: ${props => props.mainColor};
`;

const WelcomeMessage = styled.div`
  margin: 0 0 20px;
  font-size: 14px;
  text-align: center;
`;

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  & > p {
    margin: 0 0 10px;
  }
`;

export default observer(HeaderMenuContent);
